import { render } from "./single-related-products.vue?vue&type=template&id=baf02f8a"
import script from "./single-related-products.vue?vue&type=script&lang=js"
export * from "./single-related-products.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/maskingruppen-new/maskingruppen-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__